import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useState, useCallback } from 'react';
export var usePromptInput = function usePromptInput(_ref) {
  var onSubmit = _ref.onSubmit,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$clearOnSubmit = _ref.clearOnSubmit,
      clearOnSubmit = _ref$clearOnSubmit === void 0 ? true : _ref$clearOnSubmit,
      externalValue = _ref.externalValue;

  var _useState = useState(''),
      internalValue = _useState[0],
      setInternalValue = _useState[1]; // Use externalValue if provided, otherwise use internal value


  var value = externalValue !== undefined ? externalValue : internalValue;
  var setValue = useCallback(function (newValue) {
    if (externalValue === undefined) {
      setInternalValue(newValue);
    }
  }, [externalValue]); // Function to set the internal value programmatically (for suggestions)

  var setInitialValue = useCallback(function (newValue) {
    setInternalValue(newValue);
  }, []);
  var handleChange = useCallback(function (e) {
    setValue(e.target.value);
  }, [setValue]);
  var clearInput = useCallback(function () {
    setValue('');
  }, []);
  var handleSubmit = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var processed;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remove leading/trailing whitespace but preserve internal newlines
            processed = value.replace(/^\s+|\s+$/g, '');

            if (!(!processed || disabled)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return onSubmit(processed);

          case 5:
            if (clearOnSubmit) clearInput();

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [value, disabled, onSubmit, clearOnSubmit, setValue]);
  var handleKeyDown = useCallback(function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      handleSubmit();
    }
  }, [handleSubmit]);
  return {
    value: value,
    setValue: setValue,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    handleKeyDown: handleKeyDown,
    clearInput: clearInput,
    setInitialValue: setInitialValue,
    disabled: disabled
  };
};